import { useNavigate } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';
import { ROUTES } from '@/constants';
import { useSICReport } from '../../hooks/useSICReport';
import { SICStatusCard } from '../../components/SICStatusCard';
import { SICActionsCard } from '../../components/SICActionsCard';
import { SICAttentionCard } from '../../components/SICAttentionCard';
import { SICHistoryTable } from '../../components/SICHistoryTable';

const BREADCRUMBS = [
    { label: 'Inicio', path: ROUTES.DASHBOARD },
    { label: 'Operaciones', path: ROUTES.SIC_REPORT },
    { label: 'Reporte SIC', path: ROUTES.SIC_REPORT },
];

export function SICReportPage() {
    const navigate = useNavigate();
    const sic = useSICReport();

    const handleOpenDetail = (reportId: string, runDate: string) => {
        navigate(`${ROUTES.SIC_REPORT}/${encodeURIComponent(reportId)}?runDate=${encodeURIComponent(runDate)}`);
    };

    const handleClickAttentionAccount = (_creditId: string) => {
        // TODO: navigate al expediente del cliente. Ruta existe pero requiere directory_id.
    };

    return (
        <div className="space-y-4">
            <PageHeader
                title="Reporte a Círculo de Crédito"
                subtitle="Reporte automático diario de cartera crediticia"
                breadcrumbs={BREADCRUMBS}
            />
            <SICStatusCard status={sic.status} isLoading={sic.statusLoading} />
            <SICActionsCard
                partnerId={sic.partnerId}
                isRunning={sic.isRunning}
                runResult={sic.runResult}
                runError={sic.runError as Error | null}
                onRunManual={sic.runManual}
            />
            <SICAttentionCard
                items={sic.attention}
                isLoading={sic.attentionLoading}
                onClickAccount={handleClickAttentionAccount}
            />
            <SICHistoryTable
                items={sic.history}
                isLoading={sic.historyLoading}
                onOpenDetail={handleOpenDetail}
            />
        </div>
    );
}
